import React, { useEffect, useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import LibrarySection from "@react/projects/panorama/components/LibrarySection"
import { fetchLibrary } from "@react/projects/panorama/api/library"
import { useEndpoints } from "../context/EndpointsContext"

const t = (key, options) => I18n.t(`quotes.builder.library_tab.${key}`, options)

// Once the quote is a chantier, its documents are read here and handled there.
const LibraryTab = () => {
  const { library_url } = useEndpoints()
  const [library, setLibrary] = useState(null)
  const [failed,  setFailed]  = useState(false)

  useEffect(() => {
    let alive = true
    setFailed(false)
    fetchLibrary(library_url)
      .then(payload => alive && (payload?.create_url ? setLibrary(payload) : setFailed(true)))
      .catch(() => alive && setFailed(true))
    return () => { alive = false }
  }, [library_url])

  if (failed) {
    return (
      <div className="py-16 text-center text-[12.5px] text-rose-700">
        {I18n.t("projects.library.errors.network")}
      </div>
    )
  }

  if (!library) {
    return (
      <div className="py-16 text-center text-slate-400">
        <FontAwesomeIcon icon="spinner" spin />
      </div>
    )
  }

  const notice = library.project && (
    <div className="mb-3 px-3 py-2 rounded-md bg-sky-50 border border-sky-200 text-sky-800 text-[12.5px] flex items-center gap-2">
      <FontAwesomeIcon icon="helmet-safety" className="text-[12px]" />
      <span className="flex-1">{t("moved", { name: library.project.name })}</span>
      <a href={library.project.library_url} className="font-semibold underline hover:text-sky-950">{t("open_project")}</a>
    </div>
  )

  return (
    <LibrarySection
      key      = {library_url}
      library  = {library}
      title    = {t("title")}
      subtitle = {t("subtitle")}
      notice   = {notice}
      padded   = {false}
    />
  )
}

export default LibraryTab
